// Shared MUI DataGrid styles for consistent layout and typography.
export const commonDataGridStyles = {
  width: '100%',
  '& .MuiDataGrid-root': {
    overflow: 'visible',
    fontFamily: 'Montserrat, sans-serif',
  },
  '& .MuiDataGrid-virtualScroller': {
    overflowX: 'auto',
    overflowY: 'auto',
  },
  '& .MuiDataGrid-columnHeaders': {
    overflow: 'visible',
    borderBottom: '1px solid #d0d0d0',
    backgroundColor: '#EBEBEB',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    whiteSpace: 'normal',
    lineHeight: 1.4,
    overflow: 'visible',
    wordBreak: 'break-word',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  '& .MuiDataGrid-columnSeparator': {
    visibility: 'visible',
  },
  '& .MuiDataGrid-columnHeader': {
    borderRight: '1px solid #d0d0d0',
    justifyContent: 'center',
    textAlign: 'center',
    backgroundColor: '#EBEBEB',
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      justifyContent: 'center',
    },
    '& .MuiDataGrid-columnHeaderDraggableContainer': {
      justifyContent: 'center',
    },
  },
  '& .MuiDataGrid-columnHeader[data-align="left"], & .MuiDataGrid-columnHeader--alignLeft':
    {
      textAlign: 'left',
      justifyContent: 'flex-start',
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        justifyContent: 'flex-start',
      },
      '& .MuiDataGrid-columnHeaderDraggableContainer': {
        justifyContent: 'flex-start',
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        textAlign: 'left',
      },
    },
  '& .MuiDataGrid-columnHeader[data-align="right"], & .MuiDataGrid-columnHeader--alignRight':
    {
      textAlign: 'right',
      justifyContent: 'flex-end',
      '& .MuiDataGrid-columnHeaderTitleContainer': {
        justifyContent: 'flex-end',
      },
      '& .MuiDataGrid-columnHeaderDraggableContainer': {
        justifyContent: 'flex-end',
      },
      '& .MuiDataGrid-columnHeaderTitle': {
        textAlign: 'right',
      },
    },
  '& .MuiDataGrid-cell': {
    whiteSpace: 'normal',
    lineHeight: 1.4,
    overflow: 'visible',
    textOverflow: 'unset',
    borderRight: '1px solid #d0d0d0',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    padding: '8px 12px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .MuiDataGrid-cell[data-align="left"], & .MuiDataGrid-cell--alignLeft, & .MuiDataGrid-cell--textLeft':
    {
      textAlign: 'left',
      justifyContent: 'flex-start',
    },
  '& .MuiDataGrid-cell[data-align="right"], & .MuiDataGrid-cell--alignRight, & .MuiDataGrid-cell--textRight':
    {
      textAlign: 'right',
      justifyContent: 'flex-end',
    },
  '& .MuiDataGrid-cellContent': {
    overflow: 'visible',
    textOverflow: 'unset',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    overflowWrap: 'anywhere',
    textAlign: 'inherit',
  },
  '& .MuiDataGrid-row:nth-of-type(odd)': {
    backgroundColor: '#f7f7f7',
  },
  '& .MuiDataGrid-row:nth-of-type(even)': {
    backgroundColor: '#ffffff',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '& .MuiDataGrid-row.Mui-selected': {
    backgroundColor: '#eeb214 !important',
    color: 'black',
    '&:hover': {
      backgroundColor: '#d9a013 !important',
    },
  },
  '& .MuiTablePagination-root p': {
    margin: 0,
  },
  '& .MuiTablePagination-root p': {
    margin: 0,
  },
};
